export enum SignatureStatus {
  Inactive = 'inactive', //when signature request is not longer required, but we need to keep in db to tell signer.
  Pending = 'pending', //default status when signature goes out. This state allows signer to view and verify application
  Verified = 'verified', //signer action: application info verified
  Rejected = 'rejected', //signer action: application info rejected (declined to verify)
  Completed = 'completed', //signature request complete: verified and application submitted
}
